export enum MenuItemsEnum {
  LogIn = 'Zaloguj się',
  LogOut = 'Wyloguj się',
  MyAccount = 'Moje konto',
  OcAcCalculator = 'Kalkulator OC/AC',
  SkpRegistration = 'Dołącz do programu',
}
